import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { DateRangeKey, DATE_RANGES, DEFAULT_RANGE } from "../types";

/**
 * The Home tab's date range lives in `?range=` so a particular view is
 * linkable — an admin can paste "the last 7 days" at someone rather than
 * describing which button to press.
 */
export const useDateRange = (): [DateRangeKey, (next: DateRangeKey) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get("range");
  const range = DATE_RANGES.some(option => option.key === raw)
    ? (raw as DateRangeKey)
    : DEFAULT_RANGE;

  const setRange = useCallback(
    (next: DateRangeKey) => {
      const params = new URLSearchParams(searchParams);
      params.set("range", next);
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return [range, setRange];
};
